import { createSelector } from 'reselect';
import { getState } from 'store/utils';

export const getAdminSettingsStore = createSelector(getState, (state) => state.adminSettings);

export const getAdminSettingsVersionStrategy = createSelector(getAdminSettingsStore, (state) => state.versionStrategy);
